import { OrganizationStatusEnum } from "types/organization/OrganizationStatusEnum";

/** Title of the admin subscriptions page, its nav entry and its browser tab. */
export const ADMIN_SUBSCRIPTIONS_TITLE = "Subscriptions";

/** Fixed labels of the admin subscriptions page. */
export const ADMIN_SUBSCRIPTIONS_LABELS = {
  includeTestAccounts: "Include test accounts",
  refresh: "Refresh",
  loading: "Loading…",
  usersCardTitle: "Users",
  organizationsCardTitle: "Organizations",
  noUsers: "No users.",
  noOrganizations: "No organizations.",
  testAccountBadge: "Test",
  cancelsAtPeriodEndBadge: "Cancels at period end",
  noValue: "—",
  fallbackError: "Couldn't load subscriptions. Try again.",
};

/** Column headers of the users table. */
export const ADMIN_USER_SUBSCRIPTION_COLUMNS = {
  email: "Email",
  plan: "Plan",
  status: "Status",
  periodEnds: "Period ends",
  scheduledChange: "Scheduled change",
  signedUp: "Signed up",
};

/** Column headers of the organizations table. */
export const ADMIN_ORGANIZATION_SUBSCRIPTION_COLUMNS = {
  organization: "Organization",
  plan: "Plan",
  organizationStatus: "Org status",
  subscriptionStatus: "Subscription",
  concurrency: "Concurrency",
  periodEnds: "Period ends",
  owner: "Owner",
  created: "Created",
};

/**
 * Admin-facing label of each organization lifecycle status. Distinct from the customer-facing
 * organization card, which deliberately shows CANCELED as "Payment failed".
 */
export const ORGANIZATION_STATUS_LABELS: Record<OrganizationStatusEnum, string> = {
  [OrganizationStatusEnum.ACTIVE]: "Active",
  [OrganizationStatusEnum.SUSPENDED]: "Suspended",
  [OrganizationStatusEnum.CANCELED]: "Canceled",
};
